export default "__VITE_ASSET__CFq8PIKD__"